import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { workerActions } from "../../../../../store/slices/workers";

const UIText = {
  "es-CL": {
    starting: "Eliminando grupo...",
    success: "Grupo eliminado exitosamente",
    error: "Error al eliminar grupo: ",
  },
  "en-US": {
    starting: "Deleting group...",
    success: "Group deleted successfully",
    error: "Error deleting group: ",
  },
};

export const deleteGroupId = "deleteGroup";

export const deleteGroup = ({ group, cloner_key, server, locale }) => {
  return async (dispatch) => {
    const { success, error } = UIText[locale];

    dispatch(workerActions.start(deleteGroupId));
    try {
      const url = server + "api/groups";
      await axios.delete(url, { params: { group }, headers: { cloner_key } });

      enqueueSnackbar(success, { variant: "success" });
      dispatch(workerActions.finish({ id: deleteGroupId }));
    } catch (e) {
      console.error(e);
      enqueueSnackbar(error + e.message, { variant: "error" });
      dispatch(workerActions.finish({ id: deleteGroupId, error: e.message }));
    }
  };
};
